<div fxLayout="row" fxFlex="100">
  <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
      <div fxFlex="15" fxFlex.gt-sm="15">
        <label for="Content">Marqueurs</label>
      </div>
    </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
      <div fxFlex="25" fxFlex.gt-sm="25" class="marker-name">
        {{dynamicReasonsMarker}}
      </div>
      <div fxFlex="5" fxFlex.gt-sm="5" class="marker-state">
        <span class="material-icons" tooltip="Présent" *ngIf="dynamicReasonsMarkerFound">check</span>
        <span class="material-icons" tooltip="Absent" *ngIf="!dynamicReasonsMarkerFound">not_interested</span>
      </div>
      <div fxFlex="70" fxFlex.gt-sm="70" class="marker-description">
        (Facultatif) Raisons de rejections possibles
      </div>
    </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="dynamicPortalUrlMarkerIsMandatory">
      <div fxFlex="25" fxFlex.gt-sm="25" class="marker-name">
        {{dynamicPortalUrlMarker}}
      </div>
      <div fxFlex="5" fxFlex.gt-sm="5" class="marker-state">
        <span class="material-icons" tooltip="Présent" *ngIf="dynamicPortalUrlMarkerFound">check</span>
        <span class="material-icons" tooltip="Absent" *ngIf="!dynamicPortalUrlMarkerFound">not_interested</span>
      </div>
      <div fxFlex="70" fxFlex.gt-sm="70" class="marker-description">
        (Obligatoire) URL générée du portail externe
      </div>
    </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="dynamicAccessCodeMarkerIsMandatory">
      <div fxFlex="25" fxFlex.gt-sm="25" class="marker-name">
        {{dynamicAccessCodeMarker}}
      </div>
      <div fxFlex="5" fxFlex.gt-sm="5" class="marker-state">
        <span class="material-icons" tooltip="Présent" *ngIf="dynamicAccessCodeMarkerFound">check</span>
        <span class="material-icons" tooltip="Absent" *ngIf="!dynamicAccessCodeMarkerFound">not_interested</span>
      </div>
      <div fxFlex="70" fxFlex.gt-sm="70" class="marker-description">
        (Obligatoire) Code PIN d'accès au portail externe
      </div>
    </div>
  </div>
</div>
